var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',{staticClass:"d-flex justify-content-center"},[_vm._v(_vm._s(_vm.title))]),_c('canvas',{staticClass:"w-100 my-auto",attrs:{"id":_vm.idCanva}}),_c('LoadingCover',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }